/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { spotlightStarBorder } from '@zcode-ui/icons'
import React from 'react'

interface Props {
  hovered?: boolean
  isActive: boolean
  isSpotlight?: boolean
  isVisited: boolean
  priceTxt: string
}

export const PinWithInfo = ({ hovered, isActive, isSpotlight, isVisited, priceTxt }: Props) => {
  return (
    <div className="relative drop-shadow-[0px_4px_8px_rgba(0,0,0,0.2)] -translate-y-[3px]">
      <div
        className={`flex items-center border border-solid rounded font-body h-5 px-1 text-xs font-bold ${
          isActive || hovered
            ? 'bg-gray-50 text-blue-900'
            : isVisited
              ? 'bg-neutral-650 text-gray-0'
              : 'bg-blue-800 text-gray-0'
        } ${isActive ? 'border-pink-600' : hovered ? 'border-neutral-650' : 'border-gray-0'}`}
      >
        {isSpotlight && (
          <div className="absolute -top-[8px] -right-[7px] z-100 z-4">
            <img alt="" src={spotlightStarBorder} />
          </div>
        )}
        {priceTxt}
      </div>
      <div
        className={`absolute left-1/2 h-0 w-0 -translate-x-1/2 -translate-y-[1px] border border-x-[4px] border-t-[4px] border-x-transparent border-solid ${isActive ? 'border-t-pink-600' : hovered ? 'border-t-neutral-650' : 'border-t-gray-0'}`}
      >
        <div
          className={`absolute left-1/2 h-0 w-0 -translate-x-[2px] -translate-y-[4px] border-x-[2px] border-t-[2px] border-x-transparent border-solid ${isActive || hovered ? 'border-t-gray-0' : isVisited ? 'border-t-neutral-650' : 'border-t-blue-800'}`}
        />
      </div>
    </div>
  )
}
